<template>
<div>
  <div>
    <div class="box" v-bind:style="background">
      <Title :title="title" :message="message"/>
    </div>
    <div class="container-fluid content">
      <div class="row">
        <div class="col-xs-12 col-lg-7 resizeimage">
          <img src="@/assets/cargo-content-1.jpg"/>
        </div>
        <div class="col-xs-12 col-lg-5 order-md-first disc">
          <div class="table-container">
            <div class="table-title text">
              <div class="table-caption">
                車両案内
              </div>
              20t~50tまで、お客様のご要望に合わせて車両をご用意いたします。
            </div>
            <table class="table type-table">
              <tbody>
                <tr>
                  <th>大型トレーラー（20t~50t）</th>
                  <td>25台</td>
                </tr>
                <tr>
                  <th class="no-border"> 大型トラクタ（16~20t）</th>
                  <td class="no-border">15台</td>
                </tr>
                <tr>
                  <th class="no-border"> 大型トラック（11~15t）</th>
                  <td class="no-border">10台</td>
                </tr>
                <tr>
                  <th class="no-border">ラフタークレーン（25t）</th>
                  <td class="no-border">2台</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid content">
      <div class="row">
        <div class="col-xs-12 col-lg-7 resizeimage">
          <img src="@/assets/cargo-content-2.png"/>
        </div>
        <div class="col-xs-12 col-lg-5 resizeimage disc">
          <div class="table-container">
            <div class="table-title text">
              <div class="table-caption">
                輸送実績
              </div>
              北海道から九州まで。
              当社の車両とドライバーが
              安全にお荷物を輸送します。
            </div>
            <table class="table">
              <tbody>
                <tr>
                  <td class="text">長年培ったノウハウをもとに、鉄道車両やヘリコプターなど、様々な大型貨物輸送を実施してきました。 ロジスティックスの根幹である安全を第一に、全国各地へお荷物を輸送します。</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="container contact-container">
      <div class="row office-box">
        <div class="col-xs-12 col-lg-6 contact">
          <span>さいたま第一営業所</span>
          〒339-0011 埼玉県さいたま市岩槻区長宮77
          T:048-799-1211｜F:048-799-0623
        </div>
        <div class="col-xs-12 col-lg-6 contact">
          <span>土浦営業所</span>
          〒300-0012 茨城県土浦市神立東2-30-25
          T:029-831-6654｜F:029-831-6659
        </div>
      </div>
    </div>
  </div>
  <script type="application/ld+json">
    {
      "@context": "http://schema.org/",
      "@type": "JobPosting",
      "title": "トラックドライバー",
      "description": "<p>大型トラックによる建設機械等の輸送</p>\n<p>※輸送エリアは首都圏を主体に全国展開となります。</p>\n<p>昭和42年に設立した『東栄運輸』。</p>\n<p>大手企業のお客様とも多数取引を交わす安定企業です。</p>\n<p>新会社の設立に伴い、【ドライバー】として活躍してくれる新メンバーを大募集！</p>\n<p>大型トラックで、建設機械などの輸送をお願いします。</p>\n<p>日・祝＋夏季・年末年始の連休もあり、メリハリのある働き方が叶います。</p>",
      "datePosted": "2020-12-01",
      "validThrough": "2021-06-01",
      "employmentType": "FULL_TIME",
      "hiringOrganization": {
        "@type": "Organization",
        "name": "東栄運輸株式会社",
        "sameAs": "https://www.toei.myweb.co.jp/cargo"
      },
      "jobLocation": {
        "@type": "Place",
        "address": {
          "@type": "PostalAddress",
          "addressRegion": "埼玉県",
          "addressLocality": "さいたま市",
          "streetAddress": "岩槻区長宮77",
          "postalCode": "339-0011",
          "addressCountry": "JP"
        }
      },
      "baseSalary": {
        "@type": "MonetaryAmount",
        "currency": "JPY",
        "value": {
          "@type": "QuantitativeValue",
          "value": "290000",
          "minValue": "290000",
          "maxValue": "400000",
          "unitText": "MONTH"
        }
      }
    }
  </script>
</div>
</template>

<script>
import Title from '@/components/Title.vue'

export default {
  components: {
    Title
  },
  data () {
    return {
      background: {
        background: '',
        position: 'relative',
        height: '100vh',
        minHeight: '300px',
        backgroundSize: 'cover',

        display: 'flex',
        flexDirection: 'column',

        letterSpacing: '0',
        color: '#FFFFFF'
      },
      title: 'CARGO',
      message: '貨物輸送50年。どこよりも安全なカーゴ'
    }
  },
  created () {
    this.background.background = "url('" + require('../assets/cargo.jpg') + "') no-repeat center center"
  }
}
</script>

<style scoped>
.content {
  padding-top: 5%;
  max-width: 1280px;
}
.table-container {
  padding: 2% 4% 4% 4%;
  white-space: pre-line;
}
.table-container.last {
  padding-bottom: 40px;
}
.table td {
  color: #000000;
  vertical-align: middle;
}
.table th {
  font-size: 24px;
  color: #000000;
  vertical-align: middle;
}
.type-table {
  font-size: 24px;
}
.type-table td{
  font-size: 24px;
  text-align: end;
}
@media screen and (max-width: 1280px) {
  .type-table td {
    font-size: 20px;
    padding-left: 0;
    padding-right: 0;
    width: 20%;
  }
  .type-table th {
    font-size: 20px;
  }
}
.table a{
  font-size: 16px;
}
.table .no-border {
  border-top: none;
}
.text {
  font-size: 16px;
}
.table-title {
  color: #000000;
  font-size: 32px;
  font-weight: bold;
  padding-bottom: 20px;
  position: relative;
}
.table-caption {
  position: absolute;
  top: -16%;
  font-size: 16px;
  color: #6F6B6B;
  font-weight: normal;
}
.box4 {
  border: 2px solid #7E7474;
  padding: 5px 14px;
  margin-top: 20px;
  margin-bottom: 11px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  right: 9px;
  bottom: 27px;
  min-width: 170px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.box4 p {
  font-size: 20px!important;
  font-weight: 600;
  color: #000000;
  margin: 0;
  padding: 0;
}
.arrow01 {
  display: block;
  width: 12px;
  height: 12px;
  border-top: solid 3px #7E7474;
  border-right: solid 3px #7E7474;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  position: absolute;
  right: 13%;
}
.caption {
  position: absolute;
  top: 0%;
  font-size: 16px;
  color: #6F6B6B;
  font-weight: normal;
}
.resizeimage {
  padding-right: 0px;
  padding-left: 0px;
  text-align: end;
  min-width: 240px;
}
.resizeimage img {
  width: 100%;
}
.resizeimage a {
  font-size: 10px;
  padding-right: 2%;
}
.disc {
  padding-top: 8px;
  padding-bottom: 8px;
  text-align: left;
}
.disc-caption {
  text-align: end;
}
.contact-container {
  padding-top: 40px;
  padding-bottom: 40px;
  white-space: pre-line;
  position: relative;
}
.contact-box {
  border: 2px solid #7E7474;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  padding: 25px 20px 25px 20px;
  margin-top: 20px;
  margin-bottom: 11px;
  margin-left: 0px;
  margin-right: 0px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  right: 9px;
  bottom: 27px;
  min-width: 170px;
  text-align: center;
}
.contact-box p {
  font-size: 16px;
  font-weight: 600;
  color: #000000;
  margin: 0;
  padding: 0;
  text-align: left;
}
.contact-box p.tel {
  font-size: 36px;
  font-weight: 600;
  color: #000000;
  margin: 0;
  padding: 0;
}
.office-box {
  padding: 0px 10% 0px 12%;
}
@media screen and (max-width: 480px) {
  .office-box {
    padding: 0px 0px 0px 0px;
  }
  .contact {
    padding-top: 12px;
    padding-bottom: 12px;
    font-size: 16px;
  }
  .contact span {
    font-size: 17px;
  }
  .resizeimage {
    padding-right: 5%;
    padding-left: 5%;
  }
  .table-title {
    font-size: 22px;
  }
}
.contact {
  padding-top: 12px;
  padding-bottom: 12px;
}
.contact span {
  font-size: 16px;
  font-weight: bold;
  color: #000000;
}
</style>



// WEBPACK FOOTER //
// src/components/Cargo.vue